import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
  Spinner,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  activateDeactivateUser,
  createUser,
  deleteUser,
  fetchAllRoles,
  fetchAllUserTypes,
  fetchBranches,
  fetchCountry,
  fetchGenders,
  fetchUsers,
  fetchUsersTableColumnNames,
  resetUsers,
  updateUser,
  updateUserPreference,
  updateUserRole,
  activateDeleteUser,
  fetchHumanCategories
} from "../../../slices/thunks";
import { getAuthUser } from "../../../helpers/utils";
import CommonTable from "../../../Components/Common/Table/CommonTable";
import ColumnSelectionModal from "../../../Components/Common/ColumnSelectionModal/ColumnSelectionModal";
import DeleteModal from "../../../Components/Common/DeleteModal";
import CommonAddModal from "../../../Components/Common/Modal/CommonAddModal";
import { type } from "@testing-library/user-event/dist/cjs/utility/type.js";
import AddUserForm from "../../../Components/Common/UserForm/AddUserForm";
import CommonDataTable from "../../../Components/Common/Table/CommonDataTable";
import usePermissions from "../../../Components/Hooks/usePermissions";
import ConfirmationModal from "../../../Components/Common/ConfirmationModal";
import AgentModal from "../../../Components/Common/AgentModal";

const labels = [
  {
    id: 1,
    labelName: "FirstName",
    fieldName: "text-box",
    name: "FirstName",
    value: "FirstName",
    required: true,
    minLength:3,
    maxLength: 50,
    errorMessage: "First Name is required",
  },
  {
    id: 2,
    labelName: "LastName",
    fieldName: "text-box",
    name: "LastName",
    value: "LastName",
    required: true,
    minLength:3,
    maxLength: 50,
    errorMessage: "Last Name is required",
  },
  {
    id: 3,
    labelName: "Email",
    fieldName: "email-box",
    placeholder:"example@domain.com",
    type: "email",
    name: "Email",
    value: "Email",
    required: true,
    errorMessage: "Email is required",
  },
  {
    id: 5,
    labelName: "Mobile",
    fieldName: "mobile-box",
    type: "tel",  
    name: "Phone",
    value: "Phone",
    required: true,
    errorMessage: "Mobile no. is required",
  },
  {
    id: 6,
    labelName: "Gender",
    fieldName: "genders",
    type: "select",
    name: "Gender",
    value: "GenderID",
    required: true,
    errorMessage: "Gender is required",
  },
  {
    id: 7,
    labelName: "User Type",
    fieldName: "user-type",
    type: "select",
    name: "UserTypeID",
    value: "UserTypeID",
    required: true,
    errorMessage: "User Type is required",
  }
];

function User() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const {user} = getAuthUser();
  const [show, setShow] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isAddOrEdit, setIsAddOrEdit] = useState("isAdd");
  const [selectedRow, setSelectedRow] = useState({});
  const [selectedIds, setSelectedIds] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [userToToggle, setUserToToggle] = useState(null);
  const [toggleLoading, setToggleLoading] = useState(false);
  const [showSwitchToSupportModal, setShowSwitchToSupportModal] = useState(false);
  const [showSwitchToConsultantModal, setShowSwitchToConsultantModal] = useState(false);
  const [userToSwitch, setUserToSwitch] = useState({});
  const [switchLoading, setSwitchLoading] = useState(false);
  const [showDelete, setShowDelete] = useState(false);


  const { users, loading, Headerload, error, tableColumnNames, module } = useSelector(
    (state) => ({
      users: state.Users.users,
      tableColumnNames: state.Users.tableColumnNames,
      loading: state.Users.loading,
      Headerload: state.Users.Headerload,
      error: state.Users.error,
      module: state.Module.module,
    })
  );


  const handleClassesClicks = (value) => {
    setShow(true);
    setIsAddOrEdit(value);
    setSelectedRow({});
  };

  const onEditClickHandler = (user, value) => {
    setSelectedRow(user);
    setIsAddOrEdit(value);
    setShow(true);
  };

  const onSwitchToSupportHandler = (userItem) => {
    setUserToSwitch(userItem);
    setShowSwitchToSupportModal(true);
  };

  const onActivateUsertHandler = (userItem) => {
    setSelectedRow(userItem);
    setShowDelete(true);
  };

  const onSwitchToConsultantHandler = (userItem) => {
    setUserToSwitch(userItem);
    setShowSwitchToConsultantModal(true);
  };

  const handleConfirmSwitchToSupport = async () => {
    if (userToSwitch) {
      setSwitchLoading(true);
      try {
        await dispatch(updateUserRole({ UserID: userToSwitch.ID, HumanServiceIDs: userToSwitch.HumanServiceIDs, RoleID: 2 })).unwrap();
      } catch (error) {
        console.error("Failed to switch user to support:", error);
      } finally {
        setSwitchLoading(false);
        setShowSwitchToSupportModal(false);
        setUserToSwitch({});
      }
    }
  };

  const handleConfirmSwitchToConsultant = async () => {
    if (userToSwitch) {
      setSwitchLoading(true);
      try {
        await dispatch(updateUserRole({ UserID: userToSwitch.ID, HumanServiceIDs: [], RoleID: 6 })).unwrap();
      } catch (error) {
        console.error("Failed to switch user to consultant:", error);
      }
      finally {
        setSwitchLoading(false);
        setShowSwitchToConsultantModal(false);
        setUserToSwitch({});
      }
    }
  };

  const handleActivateDelete = async () => {
    if (selectedRow) {
      setSwitchLoading(true);
      try {
        await dispatch(activateDeleteUser({ UserID: selectedRow.ID })).unwrap();
      } catch (error) {
        console.error("Failed to switch user to support:", error);
      } finally {
        setSwitchLoading(false);
        setShowDelete(false);
        setSelectedRow({});
      }
    }
  };


  // Formik will handle form field changes.
  // The old onChangeHandler that updated selectedRow is no longer needed for Formik-controlled fields.
  

  const onSubmitHandler = (values, { resetForm }) => {
    
    let IsSystemUser = false;
    
    // Prepare the payload
    const usersObj = {
      FirstName: values.FirstName.trim(),
      LastName: values.LastName.trim(),
      CountryCodeID: values.CountryCodeID, 
      Mobile: values.Phone,
      Email: values.Email,
      GenderID: values.Gender, 
      RoleId: 109,     
      IsSystemUser,
      UserId: user.ID,
      UserTypeID: values.UserTypeID
    };

    if (isAddOrEdit === "isEdit" && selectedRow) {
      usersObj["ID"] = selectedRow.ID; 
    }

    if (isAddOrEdit === "isAdd") {
      dispatch(createUser(usersObj));
    } else {
      dispatch(updateUser(usersObj));
    }
    resetForm();
    setShow(false);
  };

  const saveUserPreferences = async () => {
    const preferencesPayload = {
      UserId: user.ID,
      ColumnIDs: tableColumnNames.reduce((acc, column) => {
        acc[column.ID] = selectedColumns.includes(column.ID);
        return acc;
      }, {}),
    };
    
    setModalOpen(false);
    try {
      await dispatch(updateUserPreference(preferencesPayload)).unwrap();
      await dispatch(
        fetchUsersTableColumnNames({
          module: "USER",
        })
      );

    } catch (error) {
      console.error("Error updating preferences:", error);
    }
  };

  const confirmDelete = () => {
    dispatch(deleteUser({ IDs: selectedIds}))
      .then(() => {
        setSelectedIds([]);
      })
      .catch((error) => {
        console.error("Error deleting:", error);
      });
    setDeleteModal(false);
  };

  const onActiveOrDeactiveChange = (userItem, e) => {
    setUserToToggle(userItem);
    setShowConfirmationModal(true);
  };

  const handleConfirmToggleStatus = async () => {
    if (userToToggle) {
      
      setToggleLoading(true);
      try {
        await dispatch(
          activateDeactivateUser({
            ID: userToToggle.ID,
            IsActive: !userToToggle.IsActive,
          })
        ).unwrap(); 
        // Optionally, refetch users or update UI based on success
      } catch (error) {
        console.error("Failed to toggle user status:", error);
        // Handle error (e.g., show a toast message)
      } finally {
        setToggleLoading(false);
        setShowConfirmationModal(false);
        setUserToToggle(null);
      }
    }
  };



  // Formik handles validation via Yup schema, so validateField and local errors state are not needed.
  

  useEffect(() => {
    dispatch(
      fetchUsersTableColumnNames({
        module: "USER",
      })
    );
    dispatch(fetchUsers({IsSystemUser: false, ActiveUser: false }));
    dispatch(fetchAllRoles({IsActive: true , hasAccess: true}));    
    dispatch(fetchGenders());
    dispatch(fetchCountry());
    dispatch(fetchAllUserTypes({IsActive: true}));

    return () => {
      dispatch(resetUsers());
    }
  }, [dispatch]);


  // Compute permission
  const permission = (() => {
    return usePermissions(1, 4);
  })();

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(
          fetchUsersTableColumnNames({
            module: "USER",
          })
        ).unwrap();
        dispatch(fetchUsers({ IsSystemUser: false, ActiveUser: false }));
        dispatch(fetchHumanCategories());
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [dispatch]);

  const actionConfig = {
    // edit: {
    //   icon: "ri-edit-2-line",
    //   tooltip: "Edit",
    // },
    switchToSupport: {
      icon: "ri-customer-service-2-line",
      tooltip: "Switch to Support",
      onClick: onSwitchToSupportHandler,
      isVisible: (item, perm) => true
    },
    consultant: {
      icon: "ri-user-star-line",
      tooltip: "Consultant",
      onClick: onSwitchToConsultantHandler,
      isVisible: (item, perm) => item.RoleID !== 6 // Show for non-consultants
    },
    delete: {
      icon: "ri-delete-bin-2-line",
      tooltip: "Delete",
      isVisible: (item, perm) => !item.IsDelete
    },
    activate: {
      icon: "ri-user-follow-line",
      tooltip: "Activate User",
      onClick: onActivateUsertHandler,
      isVisible: (item, perm) => item.IsDelete
    },
    // permission: {
    //   icon: "ri-lock-unlock-line",
    //   tooltip: "Permission",
    //   // isVisible: (item) => item.Id != 2,
    // },
  };


  return (
    <div className="page-content">
      <Container fluid>
        <Row className="mb-3">
          <Col>
            <BreadCrumb title={t("Client User")  } />
          </Col>
        </Row>

        <div className="table-responsive mb-4">
          <Card>
            <CardHeader>
            <Row className="g-4">
                    <Col className="col-sm-auto">
                      <div>
                        <Button
                          className="btn btn-soft-danger ms-2 me-2"
                          onClick={() => setDeleteModal(true)}
                          disabled={selectedIds.length === 0 || !permission.CanDelete}
                        >
                          <i className="ri-delete-bin-2-line"></i>
                        </Button>
                        {/* {permission.CanAdd && (
                          <Button
                            color="secondary"
                            className="add-btn me-1"
                            onClick={() => handleClassesClicks("isAdd")}
                            id="create-btn"
                            disabled={loading}
                          >
                            <i className="ri-add-line align-bottom me-1 ms-1"></i>
                            {t("AddNew")}
                          </Button>
                        )} */}
                      </div>
                    </Col>
                    <Col className="col-sm">
                      <div className="d-flex justify-content-sm-end">
                        <Button
                          className="btn btn-soft"
                          onClick={() => setModalOpen(true)}
                          disabled={loading}
                        >
                          <i className="ri-filter-3-line"></i>
                        </Button>
                        <div className="search-box ms-2 me-2">
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={t("Search")}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                          <i className="ri-search-line search-icon"></i>
                        </div>
                      </div>
                    </Col>
                  </Row>
            </CardHeader>

            <CardBody>
              <div className="listjs-table" id="customerList">
           
                {loading || Headerload  ? (
                  <div className="d-flex justify-content-center align-items-center">
                    <Spinner
                      style={{ height: "3rem", width: "3rem" }}
                      className="me-2"
                    >
                      Loading...
                    </Spinner>
                  </div>
                ) : (
                  <div className="listjs-table" id="customerList">
                    {/* <CommonTable
                      data={users}
                      tableColumnNames={tableColumnNames}
                      searchTerm={searchTerm}
                      onEditClickHandler={onEditClickHandler}
                      onActiveOrDeactiveChange={onActiveOrDeactiveChange}
                      setDeleteModal={setDeleteModal}
                      setSelectedIds={setSelectedIds}
                      hasAction={true}
                      permission={permission}
                    /> */}
                      <CommonDataTable
                        data={users}
                        tableColumnNames={tableColumnNames}
                        searchTerm={searchTerm}
                        onEditClickHandler={onEditClickHandler}
                        onActiveOrDeactiveChange={onActiveOrDeactiveChange}
                        setDeleteModal={setDeleteModal}
                        setSelectedIds={setSelectedIds}
                        actionConfig={actionConfig}
                        permission={permission}
                      />
                  </div>
                )}
              </div>
            </CardBody>
          </Card>
        </div>
      </Container>

      {/* Add/Edit User Modal */}
      <CommonAddModal
        show={show}
        setShow={setShow}
        onSubmitHandler={onSubmitHandler}
        labels={labels}
        isAddOrEdit={isAddOrEdit}
        selectedItemData={selectedRow}
        FormBody={AddUserForm}
        title={isAddOrEdit === "isAdd" ? t("AddNewUser") : t("EditUser")}
        size="xl"
      />


      {/* ColumnSelectionModal */}
      <ColumnSelectionModal
        isOpen={modalOpen}
        toggle={() => setModalOpen(!modalOpen)}
        columns={tableColumnNames}
        selectedColumns={selectedColumns}
        setSelectedColumns={setSelectedColumns}
        handleSave={saveUserPreferences}
      />

      {/* Delete modal  */}
      <DeleteModal
        showDelete={deleteModal}
        setShowDelete={setDeleteModal}
        onDeleteClick={confirmDelete}
        setSelectedIds={setSelectedIds}
        // description={
        //   selectedIds.length > 1
        //     ? `Are you sure you want to delete ${selectedIds.length} selected items?`
        //     : `Are you sure you want to delete this record?`
        // }
        description={t("confirmDelete")}

      />

      {/* Confirmation Modal for Activate/Deactivate */}
      <ConfirmationModal
        show={showConfirmationModal}
        setShow={setShowConfirmationModal}
        onConfirmClick={handleConfirmToggleStatus}
        item={userToToggle}
        loading={toggleLoading}
      />

      {/* Confirmation Modal for Switch to Support */}
      <AgentModal
        show={showSwitchToSupportModal}
        setShow={setShowSwitchToSupportModal}
        onConfirmClick={handleConfirmSwitchToSupport}
        selectedRow={userToSwitch}
        setSelectedRow={setUserToSwitch}
        loading={switchLoading}
        title="Confirm Role Switch"
        description="Are you sure you want to switch this user to a support role?"
        confirmBtnText="Yes, Switch"
      />

      {/* Confirmation Modal for Switch to Consultant */}
      <ConfirmationModal
        show={showSwitchToConsultantModal}
        setShow={setShowSwitchToConsultantModal}
        onConfirmClick={handleConfirmSwitchToConsultant}
        item={userToSwitch}
        loading={switchLoading}
        title="Confirm Role Switch"
        description="Are you sure you want to switch this user to a consultant role?"
        confirmBtnText="Yes, Switch"
      />

      <ConfirmationModal
        show={showDelete}
        setShow={setShowDelete}
        onConfirmClick={handleActivateDelete}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        loading={switchLoading}
        title="Confirm Activation"
        description="Are you sure you want to activate this user?"
        confirmBtnText="Yes, Activate"
      />
    </div>
  );
}

export default User;